<template lang="pug">
.featured-challenge-for-wtentitylist
  RouterLink(
    v-if="_.has(featuredChallenge, 'id')"
    :to="{ name: 'Challenge', params: { challengeId: featuredChallenge.id } }"
  )
    figure.challenge-figure.image
      img.challenge-image.image.has-border-radius-large(
        :height="featuredChallengeImgLoaded ? '' : '130px'"
        @load="setFeaturedChallengeImgLoaded()"
        :src="_.get(featuredChallenge, 'map.image', mapImagePlaceholder())"
        @error="replaceWithDefaultImage"
      )
      template(v-if="featuredChallengeImgLoaded")
        .is-flex.featured-challenge-title-and-button-container
          .featured-challenge-for-wtentitylist-title
            .is-size-5
              RouterLink(
                v-if="featuredChallenge.id"
                :to="{ name: 'Challenge', params: { challengeId: featuredChallenge.id } }"
              ).has-text-white {{ _.get(featuredChallenge, "name", "Featured Challenge") }}
              .is-size-7.has-text-white
                div {{ betweenDates }}
                div(v-if="featuredChallenge.memberCount || featuredChallenge.teamCount") {{ participantCountText }}
          .featured-challenge-for-wtentitylist-join-button
              ChallengeJoinButton(:challenge="featuredChallenge" :is-text="false")
  .empty-state-featured.mb-1(v-else)
    figure.image
      img.has-border-radius-large(
        :height="emptyImgLoaded ? '' : '130px'"
        @load="setEmptyImgLoaded()"
        :src="require('@/assets/placeholders/empty_featured_challenge.jpg')"
      )
      template(v-if="emptyImgLoaded")
        .featured-challenge-for-wtentitylist-empty-text-container.is-flex.is-flex-direction-column.is-justify-content-flex-end
          .featured-challenge-for-wtentitylist-empty-text.has-text-white.has-text-weight-bold.is-size-4.is-size-5-tablet.is-justify-content-center.has-text-centered You're Doing Great, Keep Up The Good Work!
</template>

<script>
import { challengeMixin } from "@/mixins/challengeMixin";
import WtTitle from "@@/WtTitle/WtTitle";
import ChallengeJoinButton from "@@/Challenge/ChallengeJoinButton";

export default {
  name: "FeaturedChallengeForWtEntityList",

  components: { WtTitle, ChallengeJoinButton },

  mixins: [challengeMixin],

  props: {
    featuredChallenge: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      featuredChallengeImgLoaded: false,
      emptyImgLoaded: false
    };
  },

  computed: {
    betweenDates() {
      const startDate = this.moment(
        this._.get(this.featuredChallenge, "startDate", "")
      );
      const endDate = this.moment(
        this._.get(this.featuredChallenge, "endDate", "")
      );
      const startDateFormatted = startDate.isValid()
        ? startDate.format("MM/DD/YY")
        : " __ / __ / __ ";
      const endDateFormatted = endDate.isValid()
        ? endDate.format("MM/DD/YY")
        : " __ / __ / __ ";

      return `${startDateFormatted} - ${endDateFormatted}`;
    },

    description() {
      const description = this.mapDescription(this.featuredChallenge);

      return this._.truncate(description, { length: 150 });
    },

    participantCountText() {
      let singularText =
        this.featuredChallenge.between === "groups"
          ? this.featuredChallenge.teamCount + " Team"
          : this.featuredChallenge.memberCount + " Member";

      return this.featuredChallenge.teamCount > 1 ||
        this.featuredChallenge.memberCount > 1
        ? singularText + "s"
        : singularText;
    }
  },

  methods: {
    setEmptyImgLoaded() {
      this.emptyImgLoaded = true;
    },

    setFeaturedChallengeImgLoaded() {
      this.featuredChallengeImgLoaded = true;
    },

    replaceWithDefaultImage(event) {
      event.target.src = this.mapImagePlaceholder();
    }
  }
};
</script>

<style lang="sass" scoped>
.featured-challenge-for-wtentitylist
  .challenge-figure:after, .featured-challenge-for-wtentitylist-empty-text-container:after
    z-index: 0
    border-radius: $radius-large
    content: ''
    position: absolute
    left: 0
    top: 0
    width: 100%
    height: 100%
    display: inline-block
    background: -moz-linear-gradient(30deg, rgba(58, 48, 66, .9) 0%, rgba(0,0,0,0) 60%)
    background: -webkit-linear-gradient(30deg, rgba(58, 48, 66, .9) 0%, rgba(0,0,0,0) 60%)
    background: linear-gradient(0deg, rgba(58, 48, 66, .9) 0%, rgba(0,0,0,0) 60%)
  .featured-challenge-for-wtentitylist-title, .featured-challenge-for-wtentitylist-empty-text
    z-index: 1
  .featured-challenge-title-and-button-container
    position: absolute
    bottom: 0
    padding: 0 1rem 1rem 1rem
    align-items: flex-end
    justify-content: space-between
    width: 100%
  .featured-challenge-for-wtentitylist-empty-text-container
    position: absolute
    bottom: 0
    padding: 0 0.5rem 1rem 0.5rem
    width: 100%
</style>
